import { useTranslation } from 'react-i18next';

import { modalState } from '@/state/modal.state';

import { ConfirmDeleteModal } from '../confirm-delete-modal';

import { useDeleteProjectListing } from './use-delete-project-listing.mutation';
import { useAtomValue } from 'jotai';

export const DeleteProjectListingModal = () => {
  const modal = useAtomValue(modalState);
  const { t } = useTranslation('projects', {
    keyPrefix: 'listings',
  });
  const { deleteProjectListing } = useDeleteProjectListing();

  if (!modal || modal.state !== 'deleteProjectListing') return null;

  const handleDelete = async () => {
    await deleteProjectListing(modal.listing);
  };

  return (
    <ConfirmDeleteModal
      title={t`removeCompany`}
      description={t`areYouSureToRemove`}
      onConfirm={handleDelete}
      confirmLabel={t`remove`}
    />
  );
};
